import React from 'react';
import * as S from './all-flights.styles';
import * as C from '../common-styles.styles';
const AllFlights = ({ routesHtml, isDweb = false }) => {
  return (
    <>
      <C.Wrap isDweb={isDweb}>
        <S.WrapperAll dangerouslySetInnerHTML={{ __html: routesHtml }}></S.WrapperAll>
      </C.Wrap>
    </>
  );
};

export default AllFlights;
